// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2Mw2a","colMin":"styles_colMin__3d-6v","colCheckbox":"styles_colCheckbox__BO758"};